const TOOLTIP_DATA = {};

export default TOOLTIP_DATA;



// WEBPACK FOOTER //
// ./constants/tooltipData.ts